import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const FetchItems = () => {
  const [userItems, setUserItems] = useState([]);

  useEffect(() => {
    fetchUserItems();
  }, []);

  const fetchUserItems = async () => {
    try {
      const response = await fetch('https://backend-alien.vercel.app/api/main/user/items', {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem('userData')).authtoken}`,
        },
      });
      const data = await response.json();
      setUserItems(data.items);
    } catch (error) {
      console.error('Error fetching user items:', error.message);
    }
  };
const navigate = useNavigate();
  const handleEdit = (itemId) => {
    // Handle edit functionality here
    navigate(`/edititem/${itemId}`);
    console.log('Edit item with ID:', itemId);
  };

  const handleDelete = async (itemId) => {
    // Handle delete functionality here  
    try {
    const response = await axios.delete(`https://backend-alien.vercel.app/api/main/items/${itemId}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem('userData')).authtoken}`,
        },
      });
      if(response.status === 200){
        toast.success("Item Deleted SuccessFully")
        fetchUserItems()
      }
      else{
        toast.error("Failed To Delete Item")
      }
      console.log('Item deleted successfully:', response.data);
      // Handle any additional UI updates or actions after successful deletion
    } catch (error) {
        toast.error(error.response.data.message)
      console.error('Error deleting item:', error.message);
      // Handle error scenarios, such as displaying an error message to the user
    }
  };

  return (
    <div className="container mx-auto">
      <h1 className="text-3xl font-semibold mb-8">Your Items</h1>
      <div className="overflow-x-auto">
        <table className="min-w-full border border-gray-200">
          <thead>
            <tr>
              <th className="px-4 py-2 bg-gray-100 border-b border-gray-200 text-gray-800 font-semibold uppercase">Title</th>
              <th className="px-4 py-2 bg-gray-100 border-b border-gray-200 text-gray-800 font-semibold uppercase">Category</th>
              <th className="px-4 py-2 bg-gray-100 border-b border-gray-200 text-gray-800 font-semibold uppercase">Description</th>
              <th className="px-4 py-2 bg-gray-100 border-b border-gray-200 text-gray-800 font-semibold uppercase">Price</th>
              <th className="px-4 py-2 bg-gray-100 border-b border-gray-200 text-gray-800 font-semibold uppercase">Condition</th>
              <th className="px-4 py-2 bg-gray-100 border-b border-gray-200 text-gray-800 font-semibold uppercase">Status</th>
              <th className="px-4 py-2 bg-gray-100 border-b border-gray-200 text-gray-800 font-semibold uppercase">Location</th>
              <th className="px-4 py-2 bg-gray-100 border-b border-gray-200 text-gray-800 font-semibold uppercase">Actions</th>
            </tr>
          </thead>
          <tbody>
            {userItems.map((item) => (
              <tr key={item._id}>
                <td className="px-4 py-2 border-b border-gray-200">{item.title}</td>
                <td className="px-4 py-2 border-b border-gray-200">{item.category}</td>
                <td className="px-4 py-2 border-b border-gray-200">{item.description}</td>
                <td className="px-4 py-2 border-b border-gray-200">${item.price}</td>
                <td className="px-4 py-2 border-b border-gray-200">{item.condition}</td>
                <td className="px-4 py-2 border-b border-gray-200">{item.status}</td>
                <td className="px-4 py-2 border-b border-gray-200">{item.location}</td>
                <td className="px-4 py-2 border-b border-gray-200">
                  <button onClick={() => handleEdit(item._id)} className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-1 px-2 rounded mr-2">Edit</button>
                  <button onClick={() => handleDelete(item._id)} className="bg-red-500 hover:bg-red-600 text-white font-bold py-1 px-2 rounded">Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default FetchItems;
